module.exports = __webpack_public_path__ + "media/application/images/projects/images/england-bbfa384f2f6117163dbca9729e57620c.jpg";